<template>
  <div class="user_info_body">
    <div class="deco">
      <h3>개인</h3>
      <!-- 기본적으로 생년월일 체크를 하지만 예외가있음 -->
      <!-- 3. 개인사업자(주민등록번호 이미 수집) → 개인 : 주민등록번호 입력창 노출되어야함 -->
      <!-- 4. 법인사업자(주민등록번호 이미 수집) → 개인 : 주민등록번호 입력창 노출되어야함 -->
      <template
        v-if="
          (userInfo.businessType === 2) ||
          (userInfo.businessType === 3)
        "
      >
        <register-user @update="(val) => (user = val)"></register-user>
      </template>
      <template v-else>
        <register-user-birth-day @update="(val) => (user = val)"></register-user-birth-day>
      </template>

      <register-contact @update="(val) => (contact = val)"></register-contact>

      <register-account
        @update="(val) => (account = val)"
        :businessType="1"
        description="본인명의 계좌번호만 신청이 가능합니다.​"
      ></register-account>

      <register-agree @update="(val) => (agree = val)"></register-agree>

      <div class="bt bt50">
        <v-button @handleClick="handlePrev" class="btn02" :text="btnText.prev" />
        <v-button @handleClick="handleClick" class="btn01" :text="btnText.next" :disabled="btnDisabled" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import RegisterUser from '@/components/modules/userInfo/RegisterUser';
import RegisterUserBirthDay from '@/components/modules/userInfo/RegisterUserBirthDay';
import RegisterContact from '@/components/modules/userInfo/RegisterContact';
import RegisterAccount from '@/components/modules/userInfo/RegisterAccount';
import RegisterAgree from '@/components/modules/userInfo/RegisterAgree';
import VButton from '@/components/atoms/VButton';
import { openerPostMessageClose } from '@/utils';

export default {
  components: {
    RegisterUser,
    RegisterUserBirthDay,
    RegisterContact,
    RegisterAccount,
    RegisterAgree,
    VButton,
  },
  data() {
    return {
      user: {},
      contact: {},
      account: {},
      agree: {},
      default: {
        businessType: 1,
        businessName: '',
        businessOwnerName: '',
        businessLicenseNumber: '',
        businessEmail: '',
      },
    };
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
    btnText() {
      const isRegister = this.$route.name === 'UserInfoRegister' && this.userInfo.isFirst;
      return {
        prev: isRegister ? '이전' : '취소',
        next: isRegister ? '등록' : '변경',
      };
    },
    btnDisabled() {
      if (this.userInfo.isCheckedIdNo) {
        return !this.contact.isState || !this.account.isState || !this.agree.isState;
      } else {
        return !this.user.isState || !this.contact.isState || !this.account.isState || !this.agree.isState;
      }
    },
    request() {
      return {
        ...this.user.request,
        ...this.contact.request,
        ...this.account.request,
        ...this.agree.request,
        ...this.default,
      };
    },
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    ...mapActions('userInfo', ['setRegisterSelect', 'setUserInfo', 'getUserInfo']),
    handlePrev() {
      this.setRegisterSelect(0);
      this.$router.back();
    },
    async handleClick() {
      const apiGetReturn = await this.getUserInfo();
      if (apiGetReturn === 0) {
        const apiSetReturn = await this.setUserInfo(this.request);
        if (apiSetReturn === 0) {
          const { isRemainPoint, isFirst } = this.userInfo;
          this.openModal({
            type: 'alert',
            header: `${this.btnText.next}이 완료되었습니다.`,
            message:
              isRemainPoint && !isFirst
                ? '변경 전 적립한 포인트는 기존 사업자로 지급될 예정입니다. ​<br>포인트 전환 내역에서 내역 확인 후 ​수익 지급을 위한 세금계산서 발행을 진행해주세요.'
                : '',
            callback: () => {
              openerPostMessageClose();
              this.$router.replace({ name: 'UserInfoView' });
            },
          });
        }
      }
    },
  },
};
</script>

<style></style>
